var React = require('react');

function IcAwsEcsContainer1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st0","d":"M39.149,7.179H0.851C0.381,7.179,0,7.56,0,8.03v23.94c0,0.47,0.381,0.851,0.851,0.851h38.298\n\tc0.47,0,0.851-0.381,0.851-0.851V8.03C40,7.56,39.619,7.179,39.149,7.179z M38.298,31.119H1.702V8.881h36.596V31.119z M6.494,11.221\n\tH4.791V28.77h1.702L6.494,11.221L6.494,11.221z M11.277,11.221H9.574V28.77h1.702V11.221H11.277z M16.068,11.221h-1.702V28.77h1.702\n\tV11.221z M20.851,11.221h-1.702V28.77h1.702V11.221z M25.642,11.221H23.94V28.77h1.702V11.221z M30.426,11.221h-1.702V28.77h1.702\n\tV11.221z M35.217,11.221h-1.702V28.77h1.702V11.221z"}));
}

IcAwsEcsContainer1.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 40 40","style":{"enableBackground":"new 0 0 40 40"},"xmlSpace":"preserve"};

module.exports = IcAwsEcsContainer1;

IcAwsEcsContainer1.default = IcAwsEcsContainer1;
